export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapSigns';
export const ENTITY_EDIT_ROUTE = 'signs/sign';
